export default __webpack_public_path__ + "static/media/fighting-dark.ebb50bf8.svg";